import React, { useCallback, useEffect, useState } from "react";

import PageContainer from "../components/PageContainer";
import { Tooltip } from "flowbite-react";
import { getDocsInfo } from "../api/document";
import { toImagePath } from "../utils/globalFunctions";
import { useNavigate } from "react-router-dom";

export const infographics_mockup = [
  {
    id: "1",
    imgPath:
      "https://s3-alpha-sig.figma.com/img/e002/2160/699f2af0bdcbf102d7188fea615353d5?Expires=1735516800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YHvlGEcRQ29gcgCD7IHoxlQxx4bph7REIcD2-Jx9GmT6MbST3OQl1xcaBCc~7qCG~YzxLhkT76PyWOXyGk0zmPYn2peNJ34hHw1pSrT5XsHdyH9s0APoaAnWD3oANQz17jMvlqedwiBsvy15dt9gLdx~7EIVGy7A0rNaXTc2hLlt60qr16nwRHRPoh5AxS0HqgDSzQztbwtgxiOztkz2rVFUIuNqXd5YOwiDcx3iwftyG7mhw4gqQCI3J1IC87eBeMIiTeAzeaHxAx~E1kY45Mit8xupaXjDpAVUPgLO-ViZVMVE4h608LcrkWArbx-JRn5r9angkCHiOh6TMeOVnw__",
    title: "Infographic 1",
    detail:
      "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: "2",
    imgPath:
      "https://s3-alpha-sig.figma.com/img/e002/2160/699f2af0bdcbf102d7188fea615353d5?Expires=1735516800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YHvlGEcRQ29gcgCD7IHoxlQxx4bph7REIcD2-Jx9GmT6MbST3OQl1xcaBCc~7qCG~YzxLhkT76PyWOXyGk0zmPYn2peNJ34hHw1pSrT5XsHdyH9s0APoaAnWD3oANQz17jMvlqedwiBsvy15dt9gLdx~7EIVGy7A0rNaXTc2hLlt60qr16nwRHRPoh5AxS0HqgDSzQztbwtgxiOztkz2rVFUIuNqXd5YOwiDcx3iwftyG7mhw4gqQCI3J1IC87eBeMIiTeAzeaHxAx~E1kY45Mit8xupaXjDpAVUPgLO-ViZVMVE4h608LcrkWArbx-JRn5r9angkCHiOh6TMeOVnw__",
    title: "Infographic 2",
    detail:
      "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: "3",
    imgPath:
      "https://s3-alpha-sig.figma.com/img/e002/2160/699f2af0bdcbf102d7188fea615353d5?Expires=1735516800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YHvlGEcRQ29gcgCD7IHoxlQxx4bph7REIcD2-Jx9GmT6MbST3OQl1xcaBCc~7qCG~YzxLhkT76PyWOXyGk0zmPYn2peNJ34hHw1pSrT5XsHdyH9s0APoaAnWD3oANQz17jMvlqedwiBsvy15dt9gLdx~7EIVGy7A0rNaXTc2hLlt60qr16nwRHRPoh5AxS0HqgDSzQztbwtgxiOztkz2rVFUIuNqXd5YOwiDcx3iwftyG7mhw4gqQCI3J1IC87eBeMIiTeAzeaHxAx~E1kY45Mit8xupaXjDpAVUPgLO-ViZVMVE4h608LcrkWArbx-JRn5r9angkCHiOh6TMeOVnw__",
    title: "Infographic 3",
    detail:
      "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: "4",
    imgPath:
      "https://s3-alpha-sig.figma.com/img/e002/2160/699f2af0bdcbf102d7188fea615353d5?Expires=1735516800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YHvlGEcRQ29gcgCD7IHoxlQxx4bph7REIcD2-Jx9GmT6MbST3OQl1xcaBCc~7qCG~YzxLhkT76PyWOXyGk0zmPYn2peNJ34hHw1pSrT5XsHdyH9s0APoaAnWD3oANQz17jMvlqedwiBsvy15dt9gLdx~7EIVGy7A0rNaXTc2hLlt60qr16nwRHRPoh5AxS0HqgDSzQztbwtgxiOztkz2rVFUIuNqXd5YOwiDcx3iwftyG7mhw4gqQCI3J1IC87eBeMIiTeAzeaHxAx~E1kY45Mit8xupaXjDpAVUPgLO-ViZVMVE4h608LcrkWArbx-JRn5r9angkCHiOh6TMeOVnw__",
    title: "Infographic 4",
    detail:
      "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: "5",
    imgPath:
      "https://s3-alpha-sig.figma.com/img/97db/8728/e517e2308bc0b0e588904cf3e9c6dc9a?Expires=1734307200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HbtzfExK8ELI2YGtlcflEDBELOF~9lP3Vp9P~AeEYbwqsPkSDRKHqenQiHI4qhFUTE9SEUdXZdePBA4DDT5FimlJfRdGb-eXUPh68Yk8bqoeDkGkNUmGTPan6wAIt8BYVbapJpNi8NAq91jtgkw4gLWYNXVeZ611El4lU7cvCPjQTvHNKvMawaFRweVm~QIOja8qdkubOJZ8yOUmRSN~2ucFxpwopFCT5F64RwAZ~hlWM8MWwAQ5uOkxnfaa~WBsGZTjE245VJaQcK9gzihLJMUdYWF4pjDPclwuph0Z7Po4VcVYx8ADaO3Ium7i6FyC58ZJfIi4MjMY43nwIYSTnw__",
    title: "Infographic 5",
    detail:
      "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const Infographics = () => {
  const navigate = useNavigate();
  const [pageData, setPageData] = useState([]);

  const getData = useCallback(
    () =>
      getDocsInfo()
        .then((res) => setPageData(res.docsset))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  console.log("pageData", pageData);

  return (
    <PageContainer
      title="Infographic"
      bgImg="/images/docs/infographic-banner.png"
    >
      <section>
        <div className="container pt-10 mx-auto max-w-[800px]">
          <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-5 justify-center">
            {pageData.map((item) => (
              <Tooltip content={item.title} position="top">
                <div
                  className="w-[200px] h-[250px] rounded-lg overflow-hidden shadow-lg cursor-pointer"
                  onClick={() => navigate(`/infographics/${item.pdflink._id}`)}
                >
                  <img
                    src={toImagePath(item.cover.path)}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Infographics;
